import { VideoIntegrationType } from "@tellescope/types-models";

export const VALID_VIDEO_INTEGRATIONS = ["Zoom", "Twilio", "No Integration"] as const;
export const convertStringToVideoIntegration = (str: string): VideoIntegrationType => {
  return VALID_VIDEO_INTEGRATIONS.find((item) => item === str) ?? "No Integration";
};
